import { atom } from 'jotai';

const initialSignUpFormState: MemberInfo = {
  password: '',
  marketing: false,
  terms: false,
  personalInfo: false,
  name: '',
  phoneNumber: '',
  authNumber: '',
  isSentCode: false,
  isAuthenticateCode: false,
  dealerLicenseNumber: '',
};

export const signUpFormAtom = atom<MemberInfo>(initialSignUpFormState);
export { initialSignUpFormState };
